import { Reducer } from 'redux';
import {
    ActionTypes, SET_SIDENAV_STATE, SET_SIDENAV_SECTION_STATE
} from '../actions/layout.actions';

export interface State {
    sideNavOpen: boolean;
    sectionOpen: string;
}

const initialState: State = {
    sideNavOpen: false,
    sectionOpen: ''
};

const reducer: Reducer<State, ActionTypes> = (state = initialState, action) => {
    switch (action.type) {
        case SET_SIDENAV_STATE:
            return { ...state, sideNavOpen: action.payload };

        case SET_SIDENAV_SECTION_STATE:
            return { ...state, sectionOpen: action.payload };

        default:
            return state;
    }
};

export default reducer;
